// extracted by mini-css-extract-plugin
module.exports = {"linkBtn":"linkBtn--FJzjM","noBorderInput":"noBorderInput--1yNYG"};